<ejs-dialog id="ejDialog" #ejDialog showCloseIcon='true' header='{{customProjectNaming.level2Name}} Numbers' (beforeClose)="onDialogClose($event)"
  [visible]="isVisible" [animationSettings]='animationSettings' [target]="dialogDragTarget"
  [allowDragging]='allowDialogDragging' isModal="isModal">
  <div>
    <app-incident-numbers #componentIncidentNumbers></app-incident-numbers>
  </div>
</ejs-dialog>


